import { useRef, useEffect } from 'react';
import { AnyObject } from '../types/types';

/* eslint-disable no-console */
export const useWhyDidYouUpdate = (name: string, props: AnyObject) => {
  // Get a mutable ref object where we can store props ...
  // ... for comparison next time this hook runs.
  const previousProps = useRef(props);

  useEffect(() => {
    if (previousProps.current) {
      // Get all keys from previous and current proAnyObjectps
      const allKeys = Object.keys({ ...previousProps.current, ...props });
      // Use this object to keep track of changed props
      const changesObj: AnyObject = {};
      // Iterate through keys
      allKeys.forEach((key: string) => {
        // If previous is different from current
        if (previousProps.current[key] !== props[key]) {
          // Add to changesObj
          changesObj[key] = {
            from: previousProps.current[key],
            to: props[key],
          };
        }
      });

      // If changesObj not empty then output to console, else log the render
      if (Object.keys(changesObj).length) {
        console.log('[why-did-you-update]', name, changesObj);
      } else {
        console.log('[why-did-you-update]', name, 'entering render');
      }
    }

    // Finally update previousProps with current props for next hook call
    previousProps.current = props;
  });
};
